<div class="dropzone" dropzone (hovered)="toggleHover($event)" (dropped)="onDrop($event)" [class.hovering]="isHovering">
  <h3>AngularFire Drop Zone</h3>
  <p>Drag and Drop a File</p>
  <div class="file">
    <label class="file-label">
      <input class="file-input" type="file" (change)="onDrop($event.target.files)" multiple />
    </label>
  </div>
</div>

<h3>Uploads</h3>

<!-- <div *ngFor="let file of files">
    <upload-task [file]="file"></upload-task>
</div> -->
